export const GLP_DISTRIBUTION_TEST_ID = 4672592n;
export const GLP_DISTRIBUTION_ID = 11802763389053472339483616176459046875189472617101418668457790595837638713068n;
export const GLV_BONUS_INCENTIVE_DISTRIBUTION_TEST_ID =
  113005011054014960800824418529010340523901000236636486140352426860453188114236n;
export const GLV_BONUS_INCENTIVE_DISTRIBUTION_ID =
  64013039480962942581181820133015390730044968712377073754034637994666645393343n;
